import { lazy } from "react";

export const LazyEvaluationBackgroundRefetch = lazy(async () => ({
    default: (await import("./EvaluationBackgroundRefetch"))
        .EvaluationBackgroundRefetch
}));

export const LazyEvaluationResultsPage = lazy(async () => ({
    default: (await import("./EvaluationResultsPage")).EvaluationResultsPage
}));
